import { render } from "./cate-skeleton.vue?vue&type=template&id=fb3ad234&scoped=true"
import script from "./cate-skeleton.vue?vue&type=script&lang=js"
export * from "./cate-skeleton.vue?vue&type=script&lang=js"

import "./cate-skeleton.vue?vue&type=style&index=0&id=fb3ad234&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3ad234"]])

export default __exports__